module.exports = "/images/v_filter_wildtrak_1.jpg?06fb12a805517b95a389b6b9a96d322b";